import { render, staticRenderFns } from "./preSaleNafterSaleInsideApp.vue?vue&type=template&id=1ae86028&scoped=true&"
import script from "./preSaleNafterSaleInsideApp.vue?vue&type=script&lang=js&"
export * from "./preSaleNafterSaleInsideApp.vue?vue&type=script&lang=js&"
import style0 from "./preSaleNafterSaleInsideApp.vue?vue&type=style&index=0&id=1ae86028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae86028",
  null
  
)

export default component.exports